import { useSyncExternalStore } from 'react';
import {
  getPushStatus,
  hasAutoPromptSettled,
  subscribePushStatus,
  type PushStatus,
} from '@/lib/pushNotifications';

/** Current push notification status; re-renders when it changes anywhere in the app. */
export function usePushStatus(): PushStatus {
  return useSyncExternalStore(subscribePushStatus, getPushStatus);
}

/** Whether the automatic browser permission prompt after login has finished. */
export function useAutoPushPromptSettled(): boolean {
  return useSyncExternalStore(subscribePushStatus, hasAutoPromptSettled);
}
